export default "__VITE_ASSET__Bfg19RDF__"